import { render, staticRenderFns } from "./ChangeReminderDueDate.vue?vue&type=template&id=47f28bb7&"
import script from "./ChangeReminderDueDate.vue?vue&type=script&lang=js&"
export * from "./ChangeReminderDueDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports